import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ReleaseNoteControllerService, ReleaseNoteDto, VersionCheckDto } from '@app/generated';

@Injectable({
  providedIn: 'root',
})
export class ReleaseNoteService {
  constructor(public releaseNoteController: ReleaseNoteControllerService) {}

  getAllReleaseNotes(): Observable<ReleaseNoteDto[]> {
    return this.releaseNoteController.getAllReleaseNotes();
  }

  addReleaseNote(releaseNote: ReleaseNoteDto): Observable<any> {
    return this.releaseNoteController.add(releaseNote);
  }

  updateReleaseNote(id: number, releaseNote: ReleaseNoteDto): Observable<ReleaseNoteDto[]> {
    return this.releaseNoteController.update(id, releaseNote);
  }

  getCurrentVersion(): Observable<string> {
    return this.releaseNoteController.getCurrentVersion();
  }

  checkVersionUpdate(): Observable<VersionCheckDto> {
    return this.releaseNoteController.checkUpdate();
  }

  markVersionAsSeen(): Observable<any> {
    return this.releaseNoteController.markVersionAsSeen();
  }
}
